/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HalJson } from '../../models/hal-json';
import { SegmentIntegrationSettingsModel } from '../../models/segment-integration-settings-model';

export interface PostSegmentIntegrationsSettings$Params {
  'Active-Tenant-Identifier': string;
      body: SegmentIntegrationSettingsModel
}

export function postSegmentIntegrationsSettings(http: HttpClient, rootUrl: string, params: PostSegmentIntegrationsSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<HalJson>> {
  const rb = new RequestBuilder(rootUrl, postSegmentIntegrationsSettings.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HalJson>;
    })
  );
}

postSegmentIntegrationsSettings.PATH = '/segment-integrations/settings';
